"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var cookies = require('js-cookie');
// import {applyCacheRequest, applyCacheResponse} from './cache';
var normalizeAxiosError_1 = require("./normalizeAxiosError");
var API_TIMEOUT = 30000; // 30s
function default_1(url, tokenName, otherApiUrl, storage) {
    var _a, _b;
    if (storage === void 0) { storage = 'cookie'; }
    var axiosInstance = axios_1.default.create({
        baseURL: url,
        timeout: API_TIMEOUT,
        headers: {
            accessToken: storage === 'cookie' ? (_a = cookies.get(tokenName)) !== null && _a !== void 0 ? _a : '' : (_b = localStorage.getItem(tokenName)) !== null && _b !== void 0 ? _b : '',
            Version: '1.0',
        }
    });
    // axiosInstance.interceptors.request.use(applyCacheRequest);
    // axiosInstance.interceptors.response.use(applyCacheResponse, normalizeAxiosError);
    axiosInstance.interceptors.response.use(undefined, normalizeAxiosError_1.default);
    axiosInstance.storageApiUrl = otherApiUrl;
    return axiosInstance;
}
exports.default = default_1;
